import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import io from 'socket.io-client';
import { baseurl, imageUrl } from '../Baseurl';
import user from "../components/img/user.webp";
const socket = io(baseurl.replace('/api', ''));

export default function UserChat() {
//   const [assignee, setAssignee] = useState(null);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [messages, setMessages] = useState([]);
  const [newMsg, setNewMsg] = useState('');
  const [loadingUsers, setLoadingUsers] = useState(true);
  const [loadingMessages, setLoadingMessages] = useState(false);
  const scrollRef = useRef();

const assignee_id = localStorage.getItem("assignee_id");
const assignee = { id: parseInt(assignee_id), type: 'assignee' }; // Directly use it

//   const assignee_id = localStorage.getItem("assignee_id");


  // 🔁 Load current assignee
//   useEffect(() => {
//     const assigneeId = localStorage.getItem("assignee_id");
//     if (assigneeId) {
//       axios.get(`${baseurl}getAssigneeById/${assigneeId}`)
//         .then(res => setAssignee(res.data))
//         .catch(err => console.error("Error fetching assignee:", err));
//     }
//   }, []);
 

  // 🔁 Load users to chat with
  // 🔁 Load users from organization
useEffect(() => {
  const orgId = localStorage.getItem("organization_id"); // Make sure this is set
  if (!orgId) return;

  setLoadingUsers(true);
  axios.get(`${baseurl}getUserByOrg/${orgId}`)
    .then(res => setUsers(res.data.assignees || []))
    .catch(err => console.error("Error fetching org users:", err))
    .finally(() => setLoadingUsers(false));
}, []);


  // 🔁 Load messages when chat starts
useEffect(() => {
  if (assignee_id && selectedUser) {
    const messageQuery = {
      sender_type: 'assignee',
      sender_id: assignee_id,
      receiver_type: 'user',
      receiver_id: selectedUser.id,
    };

    console.log("Requesting messages:", messageQuery);

    setLoadingMessages(true);
    socket.emit('getMessages', messageQuery);
  }
}, [assignee_id, selectedUser]);


  // 🔁 Listen for incoming messages
useEffect(() => {
  socket.on('chatHistory', msgs => {
    console.log("Received chat history:", msgs);
    setMessages(msgs);
    setLoadingMessages(false);
    scrollToBottom();
  });

  socket.on('newMessage', msg => {
    console.log("Received new message:", msg);

    const isRelevant = (
  (msg.sender_type === 'user' && msg.sender_id === selectedUser.id &&
   msg.receiver_type === 'assignee' && msg.receiver_id == assignee_id) ||
  (msg.sender_type === 'assignee' && msg.sender_id == assignee_id &&
   msg.receiver_type === 'user' && msg.receiver_id === selectedUser.id)
);

    console.log("Is message relevant to current chat?", isRelevant);

    if (isRelevant) {
      setMessages(prev => [...prev, msg]);
      scrollToBottom();
    }
  });

  return () => {
    socket.off('chatHistory');
    socket.off('newMessage');
  };
}, [selectedUser, assignee]);


const handleSend = () => {
  if (!assignee_id || !selectedUser || !newMsg.trim()) {
    console.warn("Missing required info:", {
      assignee_id,
      selectedUser,
      newMsg
    });
    return;
  }

  const msgData = {
    sender_type: 'assignee',
    sender_id: assignee_id,
    receiver_type: 'user',
    receiver_id: selectedUser.id,
    message: newMsg.trim()
  };

  console.log("Sending message:", msgData);

  socket.emit('sendMessage', msgData);

  setNewMsg('');
};



  const scrollToBottom = () => {
    setTimeout(() => {
      scrollRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  const getDateLabel = (dateStr) => {
    const date = new Date(dateStr);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const isSameDate = (d1, d2) =>
      d1.getDate() === d2.getDate() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getFullYear() === d2.getFullYear();

    if (isSameDate(date, today)) return 'Today';
    if (isSameDate(date, yesterday)) return 'Yesterday';
    return date.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
  };

  const groupedMessages = messages.reduce((groups, msg) => {
    const date = new Date(msg.created_at || msg.timestamp);
    const key = date.toDateString();
    if (!groups[key]) groups[key] = [];
    groups[key].push(msg);
    return groups;
  }, {});

  const sortedDates = Object.keys(groupedMessages).sort(
    (a, b) => new Date(a) - new Date(b)
  );

  return (
    <div className="chat-container d-flex" style={{ height: '100vh', border: '1px solid #ddd' }}>

      {/* LEFT: User List */}
      <div className="chat-users border-end" style={{ width: '25%', overflowY: 'auto' }}>
        <div className="p-3 border-bottom bg-light fw-bold">Users</div>
        {loadingUsers ? (
          <div className="d-flex justify-content-center p-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          users.map(u => (
  <div
    key={u.id}
    onClick={() => setSelectedUser(u)}
    className={`p-2 d-flex align-items-center border-bottom chat-user-item ${selectedUser?.id === u.id ? 'bg-primary text-white' : ''}`}
    style={{ cursor: 'pointer' }}
  >
    <img
      src={user}
      alt={u.full_name}
      className="rounded-circle me-2"
      width="40"
      height="40"
    />
    <div>
      <div className="fw-bold">{u.full_name}</div>
      <small className={` ${selectedUser?.id === u.id ? ' text-white' : 'text-dark'}`}>{u.designation}</small>
    </div>
  </div>
))

        )}
      </div>

      {/* RIGHT: Chat Box */}
      <div className="chat-box d-flex flex-column w-100">
        <div className="p-3 border-bottom bg-light fw-bold">
          {selectedUser ? `${selectedUser.full_name}` : 'Select a user to start chat'}
        </div>

        <div className="flex-grow-1 p-3 overflow-auto" style={{ background: '#f9f9f9' }}>
          {/* {loadingMessages ? (
            <div className="d-flex justify-content-center align-items-center h-100">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading chat...</span>
              </div>
            </div>
          ) : ( */}
            <>
              {sortedDates.map(dateStr => {
  const msgs = groupedMessages[dateStr];
  const label = getDateLabel(dateStr);

  return (
    <div key={dateStr}>
      <div className="text-center text-muted my-2 fw-semibold"><span className='dthj'>{label}</span></div>

      {msgs.map((msg, idx) => {
        const date = new Date(msg.created_at || msg.timestamp);
        const formattedTime = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

        const isOutgoing = msg.sender_type === 'assignee'; // 🔁 Key logic for alignment

        return (
          <div
            key={idx}
            className={`mb-3 ${isOutgoing ? 'text-end' : 'text-start'}`}
          >
            <div
              className={`d-inline-block p-2 ${isOutgoing ? 'bg-chat1 text-dark' : 'bg-chat2 text-dark'}`}
              style={{ maxWidth: '75%', borderRadius: '10px' }}
            >
              <div className='ft-13'>{msg.message}</div>
              <div className="mt-1 text-muted small" style={{ fontSize: '0.75rem' }}>
                {formattedTime}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
})}

              <div ref={scrollRef}></div>
            </>
          {/* )} */}
        </div>

        <div className="p-3 border-top d-flex">
          <input
            type="text"
            className="form-control me-2"
            placeholder="Type message..."
            value={newMsg}
            onChange={(e) => setNewMsg(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSend()}
            disabled={!selectedUser || loadingMessages}
          />
          <button className="btn btn-primary" onClick={handleSend} disabled={!selectedUser || loadingMessages}>Send</button>
        </div>
      </div>
    </div>
  );
}
